'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _immutable = require('immutable');

var Immutable = _interopRequireWildcard(_immutable);

var _draggingConstants = require('./draggingConstants');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = Immutable.fromJS({
    isDragging: false,
    hoveredItems: {},
    hoveredTypes: {}
});

var updateHoveredItems = function updateHoveredItems(state, action) {
    var targetId = action.targetId,
        targetType = action.targetType;

    var updated = state.setIn(['hoveredItems', targetId], true);
    var typeList = state.get('hoveredTypes').get(targetType) || Immutable.List();
    return updated.setIn(['hoveredTypes', targetType], typeList.push(targetId));
};

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case _draggingConstants.DRAG_START:
            return state.set('isDragging', true);
        case _draggingConstants.DRAG_END:
            return initialState;
        case _draggingConstants.DRAG_OVER:
            if (state.get('hoveredItems').get(action.targetId)) return state;
            return updateHoveredItems(state, action);
        default:
            return state;
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/client/reducers/draggingReducer.js
// module id = 2040
// module chunks = 0